import { tokenAlive, jwtDecrypt } from "../../shared/JwtHelper";
import axios from "axios";
import authHeader from "../../services/AuthHeader";




const AUTH_API_URL = process.env.VUE_APP_MS_AUTH;
const CORE_API_URL = process.env.VUE_APP_MS_CORE;

const state = () => ({
  authData: {
    token: "",
    tokenExp: "",
    userId: "",
    langue: "fr",
    userName: "",
    fonction: "",
    profilaccess: "",
    adUser: false,
    name: "",
    givenname: "",
    mail: "",
    telephone: "",
    functionalities: [],
    profils:[]
  },
  loginStatus: "",
  currentClient: "",
  clients: [],
  contrats: [],
  contractsDates: [],
  dateConn: "",
});

const getters = {
  getDateConn(state) {
    if (state.dateConn == "") {
      state.dateConn = localStorage.getItem("dateConn");
    }
    return state.dateConn;
  },

  getUserId(state) {
    return state.authData.userId;
  },

  getLoginStatus(state) {
    return state.loginStatus;
  },

  getAuthData(state) {
    return state.authData;
  },

  getUserContact(state) {
    return {
      phone: state.authData.telephone,
      mail: state.authData.mail,
      internal: state.authData.adUser,
    };
  },

  getFunctionnalities(state) {
    return state.authData.functionalities;
  },

  getProfils(state) {
    return state.authData.profils;
  },

  getCompany(state) {
    return state.authData.org;
  },

  getCurrentClient(state) {
    if (state.currentClient == null || state.currentClient == "") {
      state.currentClient = localStorage.getItem("customer");
    }
    return state.currentClient;
  },

  getClients(state) {
    if (state.clients.length == 0) {
      let clients = localStorage.getItem("clients");
      if (clients != null) {
        state.clients = JSON.parse(clients);
      }
    }
    return state.clients;
  },

  getContrats(state) {
    return state.contrats;
  },

  getContractDates(state) {
    return state.contractsDates;
  },

  isAdUser(state) {
    if (!state.authData.adUser) {
      return false;
    }

    return state.authData.adUser;
  },

  isTokenActive(state) {
    if (!state.authData.tokenExp) {
      return false;
    }

    return tokenAlive(state.authData.tokenExp);
  },
};

const actions = {
  async login({ commit }, payload) {
    const response = await axios
      .post(`${AUTH_API_URL}/login`, payload)
      .catch((err) => {
        console.log(err);
      });
    if (response && response.data) {
      commit("setdateConn", new Date());
      commit("saveTokenData", response.data);
      commit("setLoginStatus", "success");
    } else {
      commit("setLoginStatus", "failed");
    }
  },

  async loadClients({ commit }) {
    const response = await axios
      .get(`${CORE_API_URL}/secure/customers`, { headers: authHeader() })
      .catch((err) => {
        console.log(err);
      });
    if (response && response.data) {
      commit("setClients", response.data);
    } else {
      commit("setClients", []);
    }
  },

  async loadContrats({ commit }, value) {
    const response = await axios
      .get(`${CORE_API_URL}/secure/agreements/${value}`, {
        headers: authHeader(),
      })
      .catch((err) => {
        console.log("store contrat:" + err);
      });
    if (response && response.data) {
      commit("setContrats", response.data);
    } else {
      commit("setContrats", []);
    }
  },

  async loadContratsDates({ commit }, payload) {
    const response = await axios
      .get(`${CORE_API_URL}/secure/agreements/${payload.client}/dates?month=${payload.date}`, {
        headers: authHeader(),
      })
      .catch((err) => {
        console.log("store contrat:" + err);
      });
    if (response && response.data) {
      commit("setContractsDates", response.data);
    } else {
      commit("setContractsDates", []);
    }
  },

  setCurrentCustomer({ commit }, value) {
    commit("setCurrentClient", value);
  },

  logout({ commit }) {
    localStorage.clear();
    commit("saveTokenData", null);
    commit("setLoginStatus", "failed");
    commit("setClients", []);
    commit("setContrats", []);
  },
};

const mutations = {
  saveTokenData(state, data) {
    if (data == null) {
      if (window.localStorage) {
        localStorage.clear();
        state.authData = {
          token: "",
          tokenExp: "",
          userId: "",
          langue: "fr",
          userName: "",
          adUser: false,
          name: "",
          givenname: "",
          fonction: "",
          profilaccess: "",
          mail: "",
          telephone: "",
          dateConn: "",
          org: "",
          functionalities: [],
          profils:[]
        };
      }
    } else {
      if (window.localStorage) {
        localStorage.setItem("access_token", data.token);
      }
      const jwtDecodedValue = jwtDecrypt(data.token);
      const newTokenData = {
        token: data.token,
        tokenExp: jwtDecodedValue.exp,
        userId: jwtDecodedValue.userDetails.id,
        userName: jwtDecodedValue.sub,
        adUser: jwtDecodedValue.userDetails.adUser,
        name: jwtDecodedValue.userDetails.name,
        fonction: jwtDecodedValue.userDetails.fonction,
        givenname: jwtDecodedValue.userDetails.givenname,
        mail: jwtDecodedValue.userDetails.mail,
        org: jwtDecodedValue.org,
        telephone: jwtDecodedValue.userDetails.mobile,
        functionalities: jwtDecodedValue.fonctionnalites,
        profils: jwtDecodedValue.userDetails.profils
      };

      (state.currentClient = jwtDecodedValue.Customer),
        (state.authData = newTokenData);
    }
  },

  setLoginStatus(state, value) {
    state.loginStatus = value;
  },

  setdateConn(state, value) {
    localStorage.setItem("dateConn", value);
    state.dateConn = value;
  },

  setClients(state, data) {
    localStorage.setItem("clients", JSON.stringify(data));
    state.clients = data;
  },

  setAccessToken(state, value) {
    state.authData.token = value;
  },

  setTokenExp(state) {
    state.authData.tokenExp = "";
  },

  setCurrentClient(state, value) {
    localStorage.setItem("customer", value);
    state.currentClient = value;
  },

  setContrats(state, value) {
    localStorage.setItem("contrats", value);
    state.contrats = value;
  },

  setContractsDates(state, value) {
    localStorage.setItem("contractsDates", value);
    state.contractsDates = value;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
